<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      :left-arrow="true"
      :z-index="10"
      :title="getNavTitle"
      @click-left="goableBack()"></van-nav-bar>
    <div class="contain">
      <div class="title-bg">验证码</div>
      <van-cell-group class="group">
        <van-password-input
          :value="code"
          :mask="false"
          :gutter="10"
          :focused="showKeyboard"
          @focus="showKeyboard = true" />
        <van-number-keyboard
          v-model="code"
          :maxlength="6"
          :show="true"
          @blur="showKeyboard = false"></van-number-keyboard>

        <div class="tips-bg">
          <span class="tips-span">收不到验证码？试试</span>
          <span @click="onIdCardInfo">&nbsp;身份信息</span>
        </div>
      </van-cell-group>
      <van-button
        class="btn"
        color="rgb(206, 29, 35)"
        round
        type="warning"
        @click="onNextAction"
        v-preventReClick="500"
        >下一步</van-button
      >
    </div>
  </div>
</template>
  
  <script>
import { mapActions } from "vuex"
import * as CustApi from "@/api/cust"
import { CellGroup, Dialog, NumberKeyboard, PasswordInput, Toast } from "vant"
import session from "../../utils/session"

export default {
  name: "settingPwd",
  components: {
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [PasswordInput.name]: PasswordInput,
    [NumberKeyboard.name]: NumberKeyboard
  },
  data() {
    return {
      showKeyboard: true,
      code: "",
      cacheParams: {
        type: 1, // 1 忘记密码 2 注册 3 登录后未设置密码 4 个人中心进入设置密码
        mobile: "",
        referrerCode: ""
      }
    }
  },
  computed: {
    getNavTitle() {
      if (this.cacheParams.type == 1) {
        return "忘记密码"
      } else if (this.cacheParams.type == 2) {
        return "注册"
      } else if (this.cacheParams.type == 3) {
        return "设置密码"
      } else if (this.cacheParams.type == 4) {
        return "设置密码"
      } else {
        return ""
      }
    }
  },
  beforeMount() {
    this.cacheParams = session.getJson("RegisterAndForgetPwdKey")
  },
  beforeDestroy() {},
  methods: {
    ...mapActions(["getUserInfo"]),
    formatter(value) {
      // 只能输入英文字母和数字
      return value.replace(/[^\w]/g, "")
    },
    onIdCardInfo() {
      session.setJson("RegisterAndForgetPwdKey", this.cacheParams)
      this.$router.push({
        name: "personalCenter-loginpwd3"
      })
    },
    onNextAction() {
      if (!this.code || this.code.length < 6) {
        this.$toast("请输入6位验证码")
        return
      }
      if (this.cacheParams.type == 2) {
        this._showLoading()
        CustApi.registerAuthCode(
          this.cacheParams.mobile,
          this.code,
          this.cacheParams.referrerCode,
          localStorage.getItem("MallEnterKey") || ""
        )
          .then((data) => {
            this._dismissLoading()
            localStorage.removeItem("MallEnterKey")
            session.setJson("RegisterAndForgetPwdKey", this.cacheParams)
            this.$router.push({
              name: "personalCenter-loginpwd4"
            })
          })
          .catch((e) => {
            this._dismissLoading()
            if (e.code == 99999) {
              Dialog.confirm({
                title: "您已经注册过了，是否需要去登录？",
                cancelButtonText: "取消",
                confirmButtonText: "去登录"
              })
                .then(() => {
                  this.$router.push("/login?chanlCode=TA")
                })
                .catch(() => {})
            } else {
              this.$toast(e.msg || e.message)
            }
          })
      } else {
        CustApi.authCode(this.cacheParams.mobile, this.code)
          .then((data) => {
            session.setJson("RegisterAndForgetPwdKey", this.cacheParams)
            this.$router.push({
              name: "personalCenter-loginpwd4"
            })
          })
          .catch((e) => {
            this.$toast(e.msg || e.message)
          })
      }
    }
  }
}
</script>
  
  <style lang="less" scoped>
.page-container {
  min-height: calc(100vh - 45px);
  background-color: white;
  overflow: hidden;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0px 0;
}
.title-bg {
  margin: 50px 20px;
  font-size: 20px;
  font-weight: 500;
}
.group {
  margin: 50px 40px;
  margin-bottom: 0px;
  .van-password-input__security li {
    // background-color: rgb(239, 240, 242);
    height: 35px;
    border-radius: 8px;
    border: 1px solid rgb(208, 211, 213);
  }
  .tips-bg {
    margin-left: 5px;
    margin-top: 50px;
    margin-bottom: 20px;
    background-color: white;
    color: rgb(42, 104, 159);
    border-color: white;
    .tips-span {
      color: black;
    }
  }
}
.btn {
  margin: 0 40px;
  height: 44px;
  width: calc(100vw - 80px);
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
}
</style>
  